import React from 'react';
import { LibraryGreyCTA } from './styles';
import { Link } from 'react-router-dom';

export const SidePlatformList: React.FC<{ platforms: string[] | undefined }> = ({ platforms }) => {
  return (
    <>
      <Link key={`${console}-list-cta-home`} to={`/log`} style={{ textDecoration: 'none' }}>
        <LibraryGreyCTA roundedAbove>Home</LibraryGreyCTA>
      </Link>
      {platforms?.map((console, i) => (
        <Link
          key={`${console}-list-cta-${i}`}
          to={`/log/${console}`}
          style={{ textDecoration: 'none' }}>
          <LibraryGreyCTA key={`${console}-list-cta-${i}`}>
            {console === 'Super Nintendo Entertainment System' ? 'SNES' : console}
          </LibraryGreyCTA>
        </Link>
      ))}
      <LibraryGreyCTA roundedBelow>All Games</LibraryGreyCTA>
    </>
  );
};
